export default class Browser {
  public static isMobile(): boolean {
    return /Mobi/i.test(window.navigator.userAgent);
  }
}
